import { useViewerRegions } from '../../hooks/use-viewer-regions';
import { usePermissions } from '../../hooks/usePermissions';
import { Permission } from '../../types/permissions';

/**
 * Whether the viewer may edit a private event: the write capability, plus
 * write breadth that covers the event's region. A director's own regions
 * include every region under them, so a Texas director can edit a Houston
 * event, the same rule the server uses. An event with no region
 * needs nation-wide write, because there is no region to match against.
 * Cancelled and completed events stay editable.
 */
export function usePrivateEventEditAccess(regionId: string | null): boolean {
  const { hasPermission, hasAnyPermission } = usePermissions();
  const { scopeRegionIds } = useViewerRegions();

  if (!hasAnyPermission(Permission.WRITE_WORKSHOPS, Permission.WRITE_ALL)) return false;
  if (hasPermission(Permission.BREADTH_WRITE_ALL)) return true;
  if (!hasPermission(Permission.BREADTH_WRITE_ASSIGNED)) return false;
  return regionId !== null && scopeRegionIds.includes(regionId);
}
